// src/components/providers/signal-provider/signal-provider.tsx
function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
  if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}
function _iterable_to_array(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties(source, excluded) {
  if (source == null) return {};
  var target = _object_without_properties_loose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _to_consumable_array(arr) {
  return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment TripsUIToastFragment on TripsUIToast {\n    analytics {\n      linkName\n      referrerId\n    }\n    text\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  mutation SharedUIWeb_RemoveTripItemProviderMutation($context: ContextInput!, $itemId: String!, $tripId: String!) {\n    removeTripItem(context: $context, itemId: $itemId, tripId: $tripId) {\n      status\n      toast {\n        ...TripsUIToastFragment\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _tagged_template_literal(["\n  mutation SharedUIWeb_SaveTripItemsProviderMutation($context: ContextInput!, $tripId: String, $criteria: TripsUISaveTripItemsCriteriaInput!) {\n    saveTripItems(context: $context, tripId: $tripId, criteria: $criteria) {\n      status\n      toast {\n        ...TripsUIToastFragment\n      }\n      url {\n        value\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject2 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _tagged_template_literal(["\n  mutation SharedUIWeb_UpdateTripItemDatesProviderMutation($context: ContextInput!, $itemId: String!, $tripId: String!, $dateRange: DateRangeInput!) {\n    updateTripItemDates(context: $context, itemId: $itemId, tripId: $tripId, dateRange: $dateRange) {\n      status\n      toast {\n        ...TripsUIToastFragment\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject3 = function _templateObject() {
    return data;
  };
  return data;
}
import React from "react";
var SignalContext = React.createContext(void 0);
var SignalProvider = function (param) {
  var children = param.children;
  var _React_useState = _sliced_to_array(React.useState([]), 2),
    subscribers = _React_useState[0],
    setSubscribers = _React_useState[1];
  var signalsRegistry = React.useMemo(function () {
    return [];
  }, []);
  var registerSignal = React.useCallback(function (signal) {
    if (!signal) {
      return {
        subscribe: null
      };
    }
    if (!signalsRegistry.find(function (signalInRegistry) {
      return Object.is(signalInRegistry, signal);
    })) {
      signalsRegistry.push(signal);
    }
    if (signal.reference) {
      var _subscribers_find;
      return {
        subscribe: (_subscribers_find = subscribers.find(function (s) {
          return s.result.reference === signal.reference;
        })) !== null && _subscribers_find !== void 0 ? _subscribers_find : null
      };
    }
    var _subscribers_find1;
    return {
      subscribe: (_subscribers_find1 = subscribers.find(function (s) {
        return s.result.type === signal.type;
      })) !== null && _subscribers_find1 !== void 0 ? _subscribers_find1 : null
    };
  }, [signalsRegistry, subscribers]);
  var onSignalEmit = React.useCallback(function (signal, callback) {
    var subscribe = registerSignal(signal).subscribe;
    if (subscribe && signal) {
      if (signal.reference && subscribe.result.reference && signal.reference === subscribe.result.reference) {
        callback(subscribe);
      }
      if (!signal.reference && signal.type === subscribe.result.type) {
        callback(subscribe);
      }
    }
  }, [registerSignal]);
  var emitSignals = React.useCallback(function (signals) {
    var typesInRegistry = signalsRegistry.map(function (signal) {
      return signal.type;
    });
    var _emitSignalInRegistry_signal_reference;
    var result = signals.filter(function (emitSignal) {
      return typesInRegistry.includes(emitSignal.signal.type);
    }).map(function (emitSignalInRegistry) {
      return {
        result: {
          type: emitSignalInRegistry.signal.type,
          reference: (_emitSignalInRegistry_signal_reference = emitSignalInRegistry.signal.reference) !== null && _emitSignalInRegistry_signal_reference !== void 0 ? _emitSignalInRegistry_signal_reference : void 0,
          values: emitSignalInRegistry.values
        }
      };
    });
    setSubscribers(result);
  }, [signalsRegistry]);
  var context = React.useMemo(function () {
    return {
      onSignalEmit: onSignalEmit,
      emitSignals: emitSignals
    };
  }, [onSignalEmit, emitSignals]);
  return /* @__PURE__ */React.createElement(SignalContext.Provider, {
    value: context
  }, children);
};
// src/components/providers/signal-provider/use-signals.ts
import React2 from "react";
function useSignals() {
  var signalContext = React2.useContext(SignalContext);
  if (signalContext === void 0) {
    throw new Error("No Trips SignalProvider found in React tree");
  }
  return signalContext;
}
// src/components/providers/signal-provider/use-emit-signals-handler.ts
import { useProvidedState } from "@shared-ui/provided-state-context";
var useEmitSignalsHandler = function (emitSignalValues) {
  var emitSignals = useSignals().emitSignals;
  var _useProvidedState = _sliced_to_array(useProvidedState(), 1),
    state = _useProvidedState[0];
  return {
    emit: function () {
      var _emitSignalValues;
      var emitValues = (_emitSignalValues = emitSignalValues) === null || _emitSignalValues === void 0 ? void 0 : _emitSignalValues.map(function (signal) {
        var values = signal.values.map(function (value) {
          switch (value.value.__typename) {
            case "TripsSignalFieldIdValue":
              {
                var fieldIdValue = value.value;
                var inputsValue = state.validatedInputs.inputFields.find(function (inputField) {
                  return inputField.inputId === fieldIdValue.id;
                });
                return {
                  __typename: value.__typename,
                  key: value.key,
                  value: inputsValue.inputValue
                };
              }
            case "TripsSignalFieldIdExistingValues":
              {
                var fieldIdExistingValues = value.value;
                var inputValues = fieldIdExistingValues.ids.map(function (id) {
                  return state.validatedInputs.inputFields.find(function (inputField) {
                    return inputField.inputId === id;
                  });
                }).map(function (inputField) {
                  return inputField.inputValue;
                });
                var _fieldIdExistingValues_prefixes;
                var combinedValues = _to_consumable_array((_fieldIdExistingValues_prefixes = fieldIdExistingValues.prefixes) !== null && _fieldIdExistingValues_prefixes !== void 0 ? _fieldIdExistingValues_prefixes : []).concat(_to_consumable_array(inputValues));
                return {
                  __typename: value.__typename,
                  key: value.key,
                  value: combinedValues
                };
              }
            default:
              return {
                __typename: value.__typename,
                key: value.key,
                value: null
              };
          }
        });
        return {
          __typename: signal.__typename,
          signal: signal.signal,
          values: values
        };
      });
      if (emitValues) {
        emitSignals(emitValues);
      }
    }
  };
};
// src/components/providers/trip-item-operations-provider/trip-item-operations-provider.tsx
import React4 from "react";
import { useMutation } from "@apollo/client";
// src/components/providers/trip-item-operations-provider/context/trip-item-operations-context.ts
import React3 from "react";
// src/components/providers/trip-item-operations-provider/get-default-operation-state.ts
function getDefaultTripItemOperationsState(defaultTripItemOperationKeys) {
  return defaultTripItemOperationKeys.reduce(function (accum, next) {
    return Object.assign(accum, _define_property({}, next, {
      status: "UNKNOWN"
    }));
  }, {});
}
// src/components/providers/trip-item-operations-provider/trip-item-operations-provider-types.ts
var TripItemOperationFailureType = /* @__PURE__ */function (TripItemOperationFailureType2) {
  TripItemOperationFailureType2["GRAPHQL"] = "GRAPHQL";
  TripItemOperationFailureType2["NO_PROVIDER"] = "NO_PROVIDER";
  TripItemOperationFailureType2["UNKNOWN"] = "UNKNOWN";
  return TripItemOperationFailureType2;
}(TripItemOperationFailureType || {});
// src/components/providers/trip-item-operations-provider/context/get-default-operation.ts
function getDefaultOperation(operationName) {
  return function () {
    return Promise.resolve({
      success: false,
      failureReason: "No TripItemOperationsProvider found in tree found while calling ".concat(operationName),
      failure: {
        type: "NO_PROVIDER" /* NO_PROVIDER */
      }
    });
  };
}
// src/components/providers/trip-item-operations-provider/context/trip-item-operations-context.ts
var defaultTripItemOperationsContext = {
  removeTripItem: getDefaultOperation("removeTripItem"),
  saveTripItems: getDefaultOperation("saveTripItems"),
  updateTripItemDates: getDefaultOperation("updateTripItemDates")
};
var TripItemOperationsContext = React3.createContext(_object_spread_props(_object_spread({}, defaultTripItemOperationsContext), {
  state: getDefaultTripItemOperationsState(Object.keys(defaultTripItemOperationsContext))
}));
// src/components/providers/trip-item-operations-provider/register-operation.ts
function registerOperation(params) {
  return function executeOperation(operation, updateState, variables) {
    updateState(function (prevState) {
      return _object_spread_props(_object_spread({}, prevState), _define_property({}, params.operationName, {
        status: "IN_PROGRESS"
      }));
    });
    return operation({
      variables: variables
    }).then(function (response) {
      if (response.errors) {
        var error = {
          failureReason: "".concat(params.operationName, " failed with graphql error(s)"),
          failure: {
            type: "GRAPHQL" /* GRAPHQL */,
            errors: response.errors
          }
        };
        updateState(function (prevState) {
          return _object_spread_props(_object_spread({}, prevState), _define_property({}, params.operationName, {
            status: "FAILURE",
            error: error
          }));
        });
        return _object_spread({
          success: false
        }, error);
      }
      if (!response.data) {
        return Promise.reject(new Error("".concat(params.operationName, " returned null data")));
      }
      updateState(function (prevState) {
        return _object_spread_props(_object_spread({}, prevState), _define_property({}, params.operationName, {
          status: "SUCCESS",
          result: response
        }));
      });
      return _object_spread({
        success: true
      }, response);
    }).catch(function (error) {
      var failureReason = "unexpected error encountered while calling ".concat(params.operationName);
      var completeErrorMessage = "".concat(failureReason, ": ").concat(_instanceof(error, Error) ? error.message : error);
      var structuredError = {
        failureReason: failureReason,
        failure: {
          type: "UNKNOWN" /* UNKNOWN */,
          error: new Error(completeErrorMessage)
        }
      };
      updateState(function (prevState) {
        return _object_spread_props(_object_spread({}, prevState), _define_property({}, params.operationName, {
          status: "FAILURE",
          error: structuredError
        }));
      });
      return _object_spread({
        success: false
      }, structuredError);
    });
  };
}
// src/components/providers/trip-item-operations-provider/operations/remove-trip-item/remove-trip-item.ts
var removeTripItem = registerOperation({
  operationName: "removeTripItem"
});
// src/components/providers/trip-item-operations-provider/operations/remove-trip-item/mutation/remove-trip-item-mutation.ts
import { gql as gql2 } from "@apollo/client";
// src/components/providers/__fragments/trips-ui-toast.ts
import { gql } from "@apollo/client";
var __TripsUIToastFragment = gql(_templateObject());
// src/__generated__/types.ts
var AlterMode = /* @__PURE__ */function (AlterMode2) {
  AlterMode2["DEBUG"] = "DEBUG";
  AlterMode2["NONE"] = "NONE";
  AlterMode2["PREVIEW"] = "PREVIEW";
  AlterMode2["RELEASED"] = "RELEASED";
  return AlterMode2;
}(AlterMode || {});
var AuthenticationState = /* @__PURE__ */function (AuthenticationState2) {
  AuthenticationState2["ANONYMOUS"] = "ANONYMOUS";
  AuthenticationState2["AUTHENTICATED"] = "AUTHENTICATED";
  AuthenticationState2["IDENTIFIED"] = "IDENTIFIED";
  return AuthenticationState2;
}(AuthenticationState || {});
var DeviceType = /* @__PURE__ */function (DeviceType2) {
  DeviceType2["APP_PHONE"] = "APP_PHONE";
  DeviceType2["APP_TABLET"] = "APP_TABLET";
  DeviceType2["CHAT_APP"] = "CHAT_APP";
  DeviceType2["DESKTOP"] = "DESKTOP";
  DeviceType2["MOBILE_PHONE"] = "MOBILE_PHONE";
  DeviceType2["MOBILE_TABLET"] = "MOBILE_TABLET";
  DeviceType2["VOICE_APP"] = "VOICE_APP";
  return DeviceType2;
}(DeviceType || {});
var PrivacyTrackingState = /* @__PURE__ */function (PrivacyTrackingState2) {
  PrivacyTrackingState2["CAN_NOT_TRACK"] = "CAN_NOT_TRACK";
  PrivacyTrackingState2["CAN_TRACK"] = "CAN_TRACK";
  return PrivacyTrackingState2;
}(PrivacyTrackingState || {});
var TripsSignalPairKey = /* @__PURE__ */function (TripsSignalPairKey2) {
  TripsSignalPairKey2["PRIMARY"] = "PRIMARY";
  TripsSignalPairKey2["SECONDARY"] = "SECONDARY";
  TripsSignalPairKey2["STATUS"] = "STATUS";
  return TripsSignalPairKey2;
}(TripsSignalPairKey || {});
var TripsSignalType = /* @__PURE__ */function (TripsSignalType2) {
  TripsSignalType2["REMOVE"] = "REMOVE";
  TripsSignalType2["UPDATE"] = "UPDATE";
  return TripsSignalType2;
}(TripsSignalType || {});
var TripsUIResponseStatus = /* @__PURE__ */function (TripsUIResponseStatus2) {
  TripsUIResponseStatus2["FAIL"] = "FAIL";
  TripsUIResponseStatus2["SUCCESS"] = "SUCCESS";
  return TripsUIResponseStatus2;
}(TripsUIResponseStatus || {});
// src/components/providers/trip-item-operations-provider/operations/remove-trip-item/mutation/remove-trip-item-mutation.ts
var __RemoveTripItemMutation = gql2(_templateObject1(), __TripsUIToastFragment);
// src/components/providers/trip-item-operations-provider/operations/save-trip-items/save-trip-items.ts
var saveTripItems = registerOperation({
  operationName: "saveTripItems"
});
// src/components/providers/trip-item-operations-provider/operations/save-trip-items/mutation/save-trip-items-mutation.ts
import { gql as gql3 } from "@apollo/client";
var __SaveTripItemsMutation = gql3(_templateObject2(), __TripsUIToastFragment);
// src/components/providers/trip-item-operations-provider/operations/update-trip-item-dates/mutation/update-trip-item-dates-mutation.ts
import { gql as gql4 } from "@apollo/client";
var __UpdateTripItemDatesMutation = gql4(_templateObject3(), __TripsUIToastFragment);
// src/components/providers/trip-item-operations-provider/operations/update-trip-item-dates/update-trip-item-dates.ts
var updateTripItemDates = registerOperation({
  operationName: "updateTripItemDates"
});
// src/components/providers/trip-item-operations-provider/trip-item-operations-provider.tsx
var TripItemOperationsProvider = function (param) {
  var children = param.children;
  var _useMutation = _sliced_to_array(useMutation(__RemoveTripItemMutation), 1),
    removeTripItemMutation = _useMutation[0];
  var _useMutation1 = _sliced_to_array(useMutation(__SaveTripItemsMutation), 1),
    saveTripItemsMutation = _useMutation1[0];
  var _useMutation2 = _sliced_to_array(useMutation(__UpdateTripItemDatesMutation), 1),
    updateTripItemDatesMutation = _useMutation2[0];
  var _React4_useState = _sliced_to_array(React4.useState(getDefaultTripItemOperationsState(Object.keys(defaultTripItemOperationsContext))), 2),
    operationState = _React4_useState[0],
    updateOperationState = _React4_useState[1];
  var value = React4.useMemo(function () {
    return {
      removeTripItem: function (variables) {
        return removeTripItem(removeTripItemMutation, updateOperationState, variables);
      },
      saveTripItems: function (variables) {
        return saveTripItems(saveTripItemsMutation, updateOperationState, variables);
      },
      updateTripItemDates: function (variables) {
        return updateTripItemDates(updateTripItemDatesMutation, updateOperationState, variables);
      },
      state: operationState
    };
  }, [operationState, removeTripItemMutation, saveTripItemsMutation, updateTripItemDatesMutation]);
  return /* @__PURE__ */React4.createElement(TripItemOperationsContext.Provider, {
    value: value
  }, children);
};
// src/components/providers/trip-item-operations-provider/hooks/use-trip-item-operations.ts
import React5 from "react";
function useTripItemOperations() {
  var _React5_useContext = React5.useContext(TripItemOperationsContext),
    removeTripItem2 = _React5_useContext.removeTripItem,
    saveTripItems2 = _React5_useContext.saveTripItems,
    updateTripItemDates2 = _React5_useContext.updateTripItemDates,
    rest = _object_without_properties(_React5_useContext, ["removeTripItem", "saveTripItems", "updateTripItemDates"]);
  return _object_spread({
    removeTripItem: React5.useCallback(removeTripItem2, []),
    saveTripItems: React5.useCallback(saveTripItems2, []),
    updateTripItemDates: React5.useCallback(updateTripItemDates2, [])
  }, rest);
}
// src/components/providers/template-context-provider/template-context-provider.tsx
import React6 from "react";
var TemplateContext = React6.createContext(void 0);
var TemplateContextProvider = function (param) {
  var children = param.children,
    signals = param.signals;
  var memoizedTemplateContextSignals = React6.useMemo(function () {
    return {
      signals: signals
    };
  }, [signals]);
  return /* @__PURE__ */React6.createElement(TemplateContext.Provider, {
    value: memoizedTemplateContextSignals
  }, children);
};
function useTemplateContext() {
  return React6.useContext(TemplateContext);
}
export { AlterMode, AuthenticationState, DeviceType, PrivacyTrackingState, SignalProvider, TemplateContextProvider, TripItemOperationFailureType, TripItemOperationsProvider, TripsSignalPairKey, TripsSignalType, TripsUIResponseStatus, __RemoveTripItemMutation, __SaveTripItemsMutation, __TripsUIToastFragment, __UpdateTripItemDatesMutation, removeTripItem, saveTripItems, updateTripItemDates, useEmitSignalsHandler, useSignals, useTemplateContext, useTripItemOperations };